<div class="notification-form-container rounded-xl h-full flex flex-col relative">
  <rk-notification-form-alert></rk-notification-form-alert>
  <!-- Header -->
  <rk-notification-form-header (closeClick)="closeForm()"></rk-notification-form-header>
  <!-- form -->
  <form
    [formGroup]="notificationForm"
    class="w-full h-full mt-2 bg-white px-6 pt-6 pb-[2px] md:mt-0 md:pt-0"
  >
    <!-- message input -->
    <rk-notification-form-title-input
      [titleControl]="notificationForm.get('title')"
    ></rk-notification-form-title-input>

    <!-- message input -->
    <rk-notification-form-message-input
      [messageControl]="notificationForm.get('message')"
    ></rk-notification-form-message-input>

    <!-- platform selection -->
    <rk-notification-form-platform-selector
      [platformControl]="notificationForm.get('platform')"
      [iOSTooltipMessage]="iOSTooltipMessage"
      (platformToggle)="togglePlatform($event)"
    >
    </rk-notification-form-platform-selector>

    <!-- language selection -->
    <div>
      <div class="flex justify-between items-center mt-[30px] mb-3">
        <div>
          <label class="font-bold">{{ 'notification-form.language' | translate }}</label>
        </div>
        <rk-switch
          [isChecked]="showLanguagePicker"
          (switched)="onLanguageToggle($event)"
        ></rk-switch>
      </div>
      <div [hidden]="!showLanguagePicker">
        <div class="language-selector-container">
          <rk-autocomplete-input
            [options]="languageList"
            [propertyExtractors]="propertyExtractors"
            (optionSelected)="onLanguageSelected($event)"
            class="w-full"
          ></rk-autocomplete-input>
        </div>
        <ul class="flex flex-wrap">
          @for (langControl of languages.controls; track langControl; let i = $index) {
            <li>
              {{ langControl.value.name[1] }}
              <fa-icon [icon]="'close'" (click)="removeLanguage(i)"></fa-icon>
            </li>
          }
        </ul>
      </div>
    </div>

    <!-- location selection -->
    <div>
      <div class="mt-[30px] mb-3">
        <div class="flex justify-between items-center">
          <div class="">
            <label class="font-bold">{{
              'notification-form.location' | translate
            }}</label>
          </div>

          <rk-switch
            [isChecked]="showLocationPicker"
            (switched)="onLocationToggle($event)"
          ></rk-switch>
        </div>
        <div class="text-[#676767]">
          {{ 'notification-form.location-search' | translate }}
        </div>
      </div>

      @if (apiLoaded$ | async) {
        <div class="mt-[15px]" [ngClass]="{ hide: !showLocationPicker }">
          <div class="relative flex items-center location-input">
            <fa-icon
              [icon]="'location-dot'"
              class="absolute left-[16px] text-[#CDCDCD]"
            ></fa-icon>
            <input
              matInput
              class="w-full"
              type="text"
              [formControl]="locationSearchControl"
              #locationSearch
              (keydown.enter)="$event.preventDefault()"
              placeholder="{{ 'notification-form.location-placeholder' | translate }}"
            />
          </div>
          <ul class="flex flex-wrap">
            @for (
              locationControl of locations.controls;
              track locationControl;
              let i = $index
            ) {
              <li>
                {{ locationControl.value.name }}
                <fa-icon [icon]="'close'" (click)="removeLocation(i)"></fa-icon>
              </li>
            }
          </ul>
        </div>
      }
    </div>

    <!-- date and time selection -->
    <div class="mb-[30px]">
      <div class="flex justify-between items-center mt-[30px] mb-3">
        <div class="label-wrapper font-bold">
          <label>{{ 'notification-form.schedule' | translate }}</label>
        </div>
        <rk-switch
          [isChecked]="showDatePicker"
          (switched)="onSchedulingToggle($event)"
        ></rk-switch>
      </div>
      <div [ngClass]="{ hide: !showDatePicker }" class="date-time-selector-container">
        <rk-date-time-picker [dateControl]="send_at"></rk-date-time-picker>
      </div>
    </div>

    <!-- deeplinks  -->
    <rk-notification-form-deeplinks
      (deeplinkSelected)="onDeeplinkSelected($event)"
      [selectedDeeplink]="notificationForm.get('deeplink').value"
    ></rk-notification-form-deeplinks>

    <!-- number of targeted subscribers -->
    <rk-notification-targeted-subscribers></rk-notification-targeted-subscribers>
  </form>

  <!-- submit buttons -->
  <div class="flex justify-end submit-buttons z-10 py-4 px-6 rounded-xl">
    <rk-button
      [variant]="'secondary'"
      [text]="'notification-form.cancel' | translate"
      (buttonClick)="closeForm()"
    ></rk-button>

    <rk-button
      type="submit"
      (buttonClick)="submitNotification()"
      [text]="
        showDatePicker
          ? ('notification-form.schedule' | translate)
          : ('notification-form.send' | translate)
      "
      [disabled]="
        notificationForm.invalid ||
        (isSubmitting$ | async) ||
        (currentApp$ | async) === null ||
        (hasTargetedSubscribers$ | async) === false
      "
      [isLoading]="isSubmitting$ | async"
    >
    </rk-button>
  </div>
</div>
